import {
    PAGE_DATA_PENDING,
    PAGE_DATA_FULFILLED,
    PAGE_DATA_REJECTED,
	PAGE_SAVE_DATA_PENDING,
	PAGE_SAVE_DATA_FULFILLED,
	PAGE_SAVE_DATA_REJECTED,
	PAGE_COMPONENT_EDIT,
    PAGE_COMPONENT_CONFIGURATION,
    PAGE_LAYOUT_CONFIGURATION,
    PAGE_ADD_PAGE,
	PAGE_COMPONENT_WRAPPER_EDIT
} from "./pageTypes";
import {CONFIG_DATA_FULFILLED, CONFIG_DATA_PENDING, CONFIG_DATA_REJECTED} from "../config/configTypes";

// NOTE: This will be hydrated from DB
const initialState = {
    // Track state for releasing the App
    initialized: false,
    // Axios Page Read\Write
    fetching: false,
    fetched: false,
	saving: false,
    error: null,
    // Tab States
    selectedTabs: [],
    // Global - direct notification to components that their settings have been changed
	componentEdit: { xId: null, xIdHint: null },
    componentUpdated: { id: null, action: null, type: null, config: null },
	componentWrapperEdit: { parentId: null, childId: null },
    // State of layout - work in progress
    quickState: {currState: 1, xId: null},
    // Page\Layout Configuration
    pages: [],
    // examplePages: [
    //     {
    //         "id": "b36003a7-1c92-4e01-919a-bbec8f935a6b",
    //         "title": "Some Page",
    //         "route": "Some Route",
    //         "icon": "Some Icon",
    //         "components": [
    //             {
    //                 id: "cc2b2b14-2c03-4ba2-b50b-be13236b6323",
    //                 type: "Layout",
    //                 config: {
    //                     layouts: {
    //                         lg: [
    //                             {i: 'b5346885-bb16-47bc-8de5-8249a7bd1473', x: 0, y: 0, w: 6, h: 1},
    //                             {i: 'a53b2c84-0ef3-4a31-88df-5246fa400880', x: 5, y: 1, w: 6, h: 2}
    //                         ],
    //                         md: [
    //                             {i: 'b5346885-bb16-47bc-8de5-8249a7bd1473', x: 0, y: 0, w: 6, h: 1},
    //                             {i: 'a53b2c84-0ef3-4a31-88df-5246fa400880', x: 5, y: 1, w: 6, h: 2}
    //                         ],
    //                         sm: [
    //                             {i: 'b5346885-bb16-47bc-8de5-8249a7bd1473', x: 0, y: 0, w: 6, h: 1},
    //                             {i: 'a53b2c84-0ef3-4a31-88df-5246fa400880', x: 5, y: 1, w: 6, h: 2}
    //                         ],
    //                         xs: [
    //                             {i: 'b5346885-bb16-47bc-8de5-8249a7bd1473', x: 0, y: 0, w: 6, h: 1},
    //                             {i: 'a53b2c84-0ef3-4a31-88df-5246fa400880', x: 5, y: 1, w: 6, h: 2}
    //                         ],
    //                         xxs: [
    //                             {i: 'b5346885-bb16-47bc-8de5-8249a7bd1473', x: 0, y: 0, w: 6, h: 1},
    //                             {i: 'a53b2c84-0ef3-4a31-88df-5246fa400880', x: 5, y: 1, w: 6, h: 2}
    //                         ]
    //                     },
    //                     components: {
    //                         'b5346885-bb16-47bc-8de5-8249a7bd1473': {
    //                             type: "TimeSeriesChart",
    //                             config: {
    //                                 title: "Top"
    //                             }
    //                         },
    //                         'a53b2c84-0ef3-4a31-88df-5246fa400880': {
    //                             id: "580ed204-0f75-4993-9bfe-11ec8f6ca1b5",
    //                             type: "Layout",
    //                             config: {
    //                                 layouts: {
    //                                     lg: [
    //                                         {i: '46b33f78-b99b-4fa9-b360-37892a23d7dc', x: 0, y: 0, w: 6, h: 1},
    //                                         {i: 'c81c4af8-5048-4f4c-9fad-fc20d14c28b4', x: 0, y: 0, w: 6, h: 1}
    //                                     ],
    //                                     md: [
    //                                         {i: '46b33f78-b99b-4fa9-b360-37892a23d7dc', x: 0, y: 0, w: 6, h: 1},
    //                                         {i: 'c81c4af8-5048-4f4c-9fad-fc20d14c28b4', x: 0, y: 0, w: 6, h: 1}
    //                                     ],
    //                                     sm: [
    //                                         {i: '46b33f78-b99b-4fa9-b360-37892a23d7dc', x: 0, y: 0, w: 6, h: 1},
    //                                         {i: 'c81c4af8-5048-4f4c-9fad-fc20d14c28b4', x: 0, y: 0, w: 6, h: 1}
    //                                     ],
    //                                     xs: [
    //                                         {i: '46b33f78-b99b-4fa9-b360-37892a23d7dc', x: 0, y: 0, w: 6, h: 1},
    //                                         {i: 'c81c4af8-5048-4f4c-9fad-fc20d14c28b4', x: 0, y: 0, w: 6, h: 1}
    //                                     ],
    //                                     xxs: [
    //                                         {i: '46b33f78-b99b-4fa9-b360-37892a23d7dc', x: 0, y: 0, w: 12, h: 1},
    //                                         {i: 'c81c4af8-5048-4f4c-9fad-fc20d14c28b4', x: 0, y: 0, w: 12, h: 1}
    //                                     ]
    //                                 },
    //                                 components: {
    //                                     '46b33f78-b99b-4fa9-b360-37892a23d7dc': {
    //                                         type: "TimeSeriesChart",
    //                                         config: {
    //                                             title: "In Nested Layout1"
    //                                         },
    //                                     },
    //                                     'c81c4af8-5048-4f4c-9fad-fc20d14c28b4': {
    //                                         type: "TimeSeriesChart",
    //                                         config: {
    //                                             title: "In Nested Layout2"
    //                                         }
    //                                     }
    //                                 }
    //                             }
    //                         }
    //                     }
    //                 }
    //             }
    //         ]
    //     },
    //     {
    //         "id": "b8ca82a4-2903-400f-9202-4d598b0fecd3",
    //         "title": "Some Page",
    //         "route": "Some Route",
    //         "icon": "Some Icon",
    //         "components": [
    //             {
    //                 id: "450b4664-0a89-4dcf-a1f5-02d4dbe363e0",
    //                 type: "Tab",
    //                 config: {
    //                     tabs: [
    //                         {
    //                             id: "dcb21319-60bc-41a7-8365-006c409f5ebe",
    //                             name: "asfd",
    //                             components: [
    //                                 {
    //                                     id: "580ed204-0f75-4993-9bfe-11ec8f6ca1b5",
    //                                     type: "Layout",
    //                                     config: {
    //                                         layouts: {
    //                                             lg: [
    //                                                 {i: '46b33f78-b99b-4fa9-b360-37892a23d7dc', x: 0, y: 0, w: 6, h: 1, static: false},
    //                                                 {i: 'c81c4af8-5048-4f4c-9fad-fc20d14c28b4', x: 0, y: 0, w: 6, h: 1, static: false}
    //                                             ],
    //                                             md: [
    //                                                 {i: '46b33f78-b99b-4fa9-b360-37892a23d7dc', x: 0, y: 0, w: 6, h: 1, static: false},
    //                                                 {i: 'c81c4af8-5048-4f4c-9fad-fc20d14c28b4', x: 0, y: 0, w: 6, h: 1, static: false}
    //                                             ],
    //                                             sm: [
    //                                                 {i: '46b33f78-b99b-4fa9-b360-37892a23d7dc', x: 0, y: 0, w: 6, h: 1, static: false},
    //                                                 {i: 'c81c4af8-5048-4f4c-9fad-fc20d14c28b4', x: 0, y: 0, w: 6, h: 1, static: false}
    //                                             ],
    //                                             xs: [
    //                                                 {i: '46b33f78-b99b-4fa9-b360-37892a23d7dc', x: 0, y: 0, w: 6, h: 1, static: false},
    //                                                 {i: 'c81c4af8-5048-4f4c-9fad-fc20d14c28b4', x: 0, y: 0, w: 6, h: 1, static: false}
    //                                             ],
    //                                             xxs: [
    //                                                 {i: '46b33f78-b99b-4fa9-b360-37892a23d7dc', x: 0, y: 0, w: 12, h: 1, static: false},
    //                                                 {i: 'c81c4af8-5048-4f4c-9fad-fc20d14c28b4', x: 0, y: 0, w: 12, h: 1, static: false}
    //                                             ]
    //                                         },
    //                                         components: {
    //                                             '46b33f78-b99b-4fa9-b360-37892a23d7dc': {
    //                                                 type: "TimeSeriesChart",
    //                                                 config: {
    //                                                     title: "In Nested Layout1"
    //                                                 },
    //                                             },
    //                                             'c81c4af8-5048-4f4c-9fad-fc20d14c28b4': {
    //                                                 type: "TimeSeriesChart",
    //                                                 config: {
    //                                                     title: "In Nested Layout2"
    //                                                 }
    //                                             }
    //                                         }
    //                                     }
    //                                 }
    //                             ]
    //                         },
    //                         {
    //                             id: "927e5d11-58e0-49b4-b680-278a7f6fe22e",
    //                             name: "asfd",
    //                             components: [
    //                                 {
    //                                     id: "3e2bb034-8e63-47ea-a61c-5b7b1be0d81a",
    //                                     type: "Layout",
    //                                     config: {
    //                                         layouts: {
    //                                             lg: [
    //                                                 {i: 'b3a9c966-39ed-4eeb-a9cf-5f2b4a687b8e', x: 0, y: 0, w: 6, h: 1},
    //                                                 {i: '6da22ce8-1c04-444d-a05f-21061c9f0c6f', x: 0, y: 0, w: 6, h: 1}
    //                                             ],
    //                                             md: [
    //                                                 {i: 'b3a9c966-39ed-4eeb-a9cf-5f2b4a687b8e', x: 0, y: 0, w: 6, h: 1},
    //                                                 {i: '6da22ce8-1c04-444d-a05f-21061c9f0c6f', x: 0, y: 0, w: 6, h: 1}
    //                                             ],
    //                                             sm: [
    //                                                 {i: 'b3a9c966-39ed-4eeb-a9cf-5f2b4a687b8e', x: 0, y: 0, w: 6, h: 1},
    //                                                 {i: '6da22ce8-1c04-444d-a05f-21061c9f0c6f', x: 0, y: 0, w: 6, h: 1}
    //                                             ],
    //                                             xs: [
    //                                                 {i: 'b3a9c966-39ed-4eeb-a9cf-5f2b4a687b8e', x: 0, y: 0, w: 6, h: 1},
    //                                                 {i: '6da22ce8-1c04-444d-a05f-21061c9f0c6f', x: 0, y: 0, w: 6, h: 1}
    //                                             ],
    //                                             xxs: [
    //                                                 {i: 'b3a9c966-39ed-4eeb-a9cf-5f2b4a687b8e', x: 0, y: 0, w: 12, h: 1},
    //                                                 {i: '6da22ce8-1c04-444d-a05f-21061c9f0c6f', x: 0, y: 0, w: 12, h: 1}
    //                                             ]
    //                                         },
    //                                         components: {
    //                                             'b3a9c966-39ed-4eeb-a9cf-5f2b4a687b8e': {
    //                                                 type: "TimeSeriesChart",
    //                                                 config: {
    //                                                     title: "In Nested Layout1"
    //                                                 },
    //                                             },
    //                                             '6da22ce8-1c04-444d-a05f-21061c9f0c6f': {
    //                                                 type: "TimeSeriesChart",
    //                                                 config: {
    //                                                     title: "In Nested Layout2"
    //                                                 }
    //                                             }
    //                                         }
    //                                     }
    //                                 }
    //                             ]
    //                         }
    //                     ]
    //                 }
    //             }
    //         ]
    //     }
    // ]
};

export default function pageReducer(state = initialState, action) {
    switch (action.type) {
        case PAGE_DATA_PENDING: {
            return {
                ...initialState,
                fetching: true
            };
        }
        case PAGE_DATA_FULFILLED: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                pages: action.payload,
                initialized: true
            };
        }
        case PAGE_DATA_REJECTED: {
            return {
                ...initialState,
                fetching: false,
                fetched: false,
                initialized: true,
                pages: [],
                error: action.payload
            };
        }
		case PAGE_SAVE_DATA_PENDING: {
			return {
				...state,
				saving: true
			}
		}
		case PAGE_SAVE_DATA_FULFILLED: {
			return {
				...state,
				saving: false,
				pages: action.payload,
				error: null
			}
		}
		case PAGE_SAVE_DATA_REJECTED: {
			return {
				...initialState,
				saving: false,
				pages: [],
				error: action.payload
			}
		}
        case PAGE_ADD_PAGE: {
            return {
                ...state,
                pages: action.payload
            }
        }
        case PAGE_LAYOUT_CONFIGURATION: {
            return {
                ...state,
                quickState: {
					currState: state.quickState.currState + 1,
					action: action.payload.action,
					xId: action.payload.id
				}
            }
        }
		case PAGE_COMPONENT_EDIT: {
			return {
				...state,
				componentEdit: {
					xId: action.payload.xId,
					xIdHint: action.payload.xIdHint
				}
			}
		}
        case PAGE_COMPONENT_CONFIGURATION: {
            return {
                ...state,
                componentUpdated: {
					id: action.payload.id,
					action: action.payload.action,
					type: action.payload.type,
					config: action.payload.config,
				}
            }
        }
		case PAGE_COMPONENT_WRAPPER_EDIT: {
			return {
				...state,
				componentWrapperEdit: action.payload
			}
		}
        default:
            return state;
    }
};
